// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CommonNavBar_link__LS7Us {
  display: flex;
  align-items: center;
  text-decoration: none;
  /* font-size: var(--mantine-font-size-lg); */
  color: #000000; /* Black color for text */
  padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);
  border-radius: var(--mantine-radius-md);
  /* font-weight: 700; */
  margin-top: 1rem;
  font-weight: 500;
  font-family: poppins;
  font-size: 16px;

  &:hover {
    background-color: #5cc6ff; /* Light blue background on hover */
    color: #ffffff; /* White text on hover */
    stroke: #006aa3;

    svg {
      stroke: black;
    }
  }
  .CommonNavBar_AdminCustomerPathIcon__MWZIX {
    fill: #006aa3 !important;
  }
  svg {
    stroke: black;
  }

  &[data-active] {
    /* background-color: #006aa3; Darker blue background for active state rgba(174, 226, 254, 0.43)*/
    background-color: #ebf8ff;
    border: 2px solid #5cc6ff;
    color: #006aa3; /* White text on hover */
    font-weight: 700;
    font-family: poppins;
    font-size: 16px;
    .CommonNavBar_svg__fGCGE {
      stroke: #006aa3;
    }

    .CommonNavBar_AdminAccountantsPathIcon__ZMp\\+z {
      fill: #006aa3 !important;
    }

    .CommonNavBar_linkIcon__lGSab {
      color: #006aa3; /* Black icon in active state */
      stroke: #006aa3;
    }
    &:hover {
      background-color: #ebf8ff; /* Light blue background on hover */
      color: #006aa3; /* White text on hover */
      font-weight: 700;
      font-family: poppins;
      font-size: 16px;
    }
    svg {
      stroke: #006aa3;
    }
    .CommonNavBar_svg-LimitedCompany__ixytW {
      stroke: #006aa3; /* Icon stroke is blue in active state */
      fill: white; /* Icon fill stays white in active state */
    }
  }
}

.CommonNavBar_linkIcon__lGSab {
  color: light-dark(var(--mantine-color-gray-6), var(--mantine-color-dark-2));
  margin-right: var(--mantine-spacing-sm);
  width: rem(25px);
  height: rem(25px);
}
.CommonNavBar_appShellHeader__HZAWt {
  display: flex;
  justify-content: center;
  align-items: center;
  border: #0077b6 1px solid;
  border-radius: 50%;
  padding: 6px;
  height: rem(40);
  width: rem(40);
}
.CommonNavBar_card__l5eWf {
  border: 2px solid var(--mantine-color-greenNeon-7);
  border-radius: 5%;
  background-color: rgb(255 255 255 / 10%);
  -webkit-backdrop-filter: blur(30px);
          backdrop-filter: blur(30px);
}
.CommonNavBar_nav__IlI-C {
  /* background: linear-gradient(to right bottom, black, var(--mantine-color-greenNeon-7) 400%); */
  background: white;
}

.CommonNavBar_control__tvOJX {
  font-weight: 500;
  display: block;
  width: 100%;
  padding: var(--mantine-spacing-xs) var(--mantine-spacing-md);
  color: var(--mantine-color-text);
  font-size: var(--mantine-font-size-sm);

  @mixin hover {
    background-color: light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-7));
    color: light-dark(var(--mantine-color-black), var(--mantine-color-dark-0));
  }
}
.CommonNavBar_chevron__tOXmw {
  transition: transform 200ms ease;
}
.CommonNavBar_drawerCloseIcon__7sjDW {
  color: black !important;
  font-size: 1.5rem !important;
  outline: 2px solid white !important;
  box-shadow: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/component/common-navBar/CommonNavBar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;EAC5C,cAAc,EAAE,yBAAyB;EACzC,4DAA4D;EAC5D,uCAAuC;EACvC,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;;EAEf;IACE,yBAAyB,EAAE,mCAAmC;IAC9D,cAAc,EAAE,wBAAwB;IACxC,eAAe;;IAEf;MACE,aAAa;IACf;EACF;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;;EAEA;IACE,gGAAgG;IAChG,yBAAyB;IACzB,yBAAyB;IACzB,cAAc,EAAE,wBAAwB;IACxC,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf;MACE,eAAe;IACjB;;IAEA;MACE,wBAAwB;IAC1B;;IAEA;MACE,cAAc,EAAE,+BAA+B;MAC/C,eAAe;IACjB;IACA;MACE,yBAAyB,EAAE,mCAAmC;MAC9D,cAAc,EAAE,wBAAwB;MACxC,gBAAgB;MAChB,oBAAoB;MACpB,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe,EAAE,wCAAwC;MACzD,WAAW,EAAE,0CAA0C;IACzD;EACF;AACF;;AAEA;EACE,2EAA2E;EAC3E,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;AACA;EACE,kDAAkD;EAClD,iBAAiB;EACjB,wCAAwC;EACxC,mCAA2B;UAA3B,2BAA2B;AAC7B;AACA;EACE,gGAAgG;EAChG,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,4DAA4D;EAC5D,gCAAgC;EAChC,sCAAsC;;EAEtC;IACE,sFAAsF;IACtF,0EAA0E;EAC5E;AACF;AACA;EACE,gCAAgC;AAClC;AACA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,mCAAmC;EACnC,2BAA2B;AAC7B","sourcesContent":[".link {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  /* font-size: var(--mantine-font-size-lg); */\n  color: #000000; /* Black color for text */\n  padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);\n  border-radius: var(--mantine-radius-md);\n  /* font-weight: 700; */\n  margin-top: 1rem;\n  font-weight: 500;\n  font-family: poppins;\n  font-size: 16px;\n\n  &:hover {\n    background-color: #5cc6ff; /* Light blue background on hover */\n    color: #ffffff; /* White text on hover */\n    stroke: #006aa3;\n\n    svg {\n      stroke: black;\n    }\n  }\n  .AdminCustomerPathIcon {\n    fill: #006aa3 !important;\n  }\n  svg {\n    stroke: black;\n  }\n\n  &[data-active] {\n    /* background-color: #006aa3; Darker blue background for active state rgba(174, 226, 254, 0.43)*/\n    background-color: #ebf8ff;\n    border: 2px solid #5cc6ff;\n    color: #006aa3; /* White text on hover */\n    font-weight: 700;\n    font-family: poppins;\n    font-size: 16px;\n    .svg {\n      stroke: #006aa3;\n    }\n\n    .AdminAccountantsPathIcon {\n      fill: #006aa3 !important;\n    }\n\n    .linkIcon {\n      color: #006aa3; /* Black icon in active state */\n      stroke: #006aa3;\n    }\n    &:hover {\n      background-color: #ebf8ff; /* Light blue background on hover */\n      color: #006aa3; /* White text on hover */\n      font-weight: 700;\n      font-family: poppins;\n      font-size: 16px;\n    }\n    svg {\n      stroke: #006aa3;\n    }\n    .svg-LimitedCompany {\n      stroke: #006aa3; /* Icon stroke is blue in active state */\n      fill: white; /* Icon fill stays white in active state */\n    }\n  }\n}\n\n.linkIcon {\n  color: light-dark(var(--mantine-color-gray-6), var(--mantine-color-dark-2));\n  margin-right: var(--mantine-spacing-sm);\n  width: rem(25px);\n  height: rem(25px);\n}\n.appShellHeader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: #0077b6 1px solid;\n  border-radius: 50%;\n  padding: 6px;\n  height: rem(40);\n  width: rem(40);\n}\n.card {\n  border: 2px solid var(--mantine-color-greenNeon-7);\n  border-radius: 5%;\n  background-color: rgb(255 255 255 / 10%);\n  backdrop-filter: blur(30px);\n}\n.nav {\n  /* background: linear-gradient(to right bottom, black, var(--mantine-color-greenNeon-7) 400%); */\n  background: white;\n}\n\n.control {\n  font-weight: 500;\n  display: block;\n  width: 100%;\n  padding: var(--mantine-spacing-xs) var(--mantine-spacing-md);\n  color: var(--mantine-color-text);\n  font-size: var(--mantine-font-size-sm);\n\n  @mixin hover {\n    background-color: light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-7));\n    color: light-dark(var(--mantine-color-black), var(--mantine-color-dark-0));\n  }\n}\n.chevron {\n  transition: transform 200ms ease;\n}\n.drawerCloseIcon {\n  color: black !important;\n  font-size: 1.5rem !important;\n  outline: 2px solid white !important;\n  box-shadow: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `CommonNavBar_link__LS7Us`,
	"AdminCustomerPathIcon": `CommonNavBar_AdminCustomerPathIcon__MWZIX`,
	"svg": `CommonNavBar_svg__fGCGE`,
	"AdminAccountantsPathIcon": `CommonNavBar_AdminAccountantsPathIcon__ZMp+z`,
	"linkIcon": `CommonNavBar_linkIcon__lGSab`,
	"svg-LimitedCompany": `CommonNavBar_svg-LimitedCompany__ixytW`,
	"appShellHeader": `CommonNavBar_appShellHeader__HZAWt`,
	"card": `CommonNavBar_card__l5eWf`,
	"nav": `CommonNavBar_nav__IlI-C`,
	"control": `CommonNavBar_control__tvOJX`,
	"chevron": `CommonNavBar_chevron__tOXmw`,
	"drawerCloseIcon": `CommonNavBar_drawerCloseIcon__7sjDW`
};
export default ___CSS_LOADER_EXPORT___;
